import cn from 'classnames';

import { useTextStyle } from '@webapp/common/components/custom-styles';
import { CssQuestionType } from '@webapp/common/components/survey-custom';
import { useMobile } from '@webapp/common/hooks/use-mobile';
import { AlignSetting } from '@webapp/common/lib/ui';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import { MatrixRatingRow } from './matrix-rating-row';

import css from './matrix-rating.css';

export const MatrixRating: VFC<SurveyQuestion> = ({
    question: {
        id: questionId,
        answersActors,
        params: { minAmount, amount, color, matrixNumbersColor, matrixType, size, cantRate, cantRateText },
    },
    questionBlockPosition,
}) => {
    const isMobile = useMobile();
    const { listStyle, textStyle } = useTextStyle();
    const adjustedSize = isMobile ? 1 : size;

    return (
        <div
            className={cn(
                CssQuestionType.QUESTION,
                CssQuestionType.STARS_MATRIX, // todo удалить
                CssQuestionType.MATRIX_RATING,
                css.list,
            )}
            style={{
                ...listStyle,
                rowGap: cantRate ? undefined : `calc(${listStyle.rowGap} * 2)`,
                ...(questionBlockPosition === AlignSetting.CENTER
                    ? {
                          gridTemplateColumns: 'auto min-content',
                          justifyContent: AlignSetting.CENTER,
                      }
                    : {}),
            }}
        >
            {answersActors.map((answerActor) => (
                <MatrixRatingRow
                    questionId={questionId}
                    answer={answerActor}
                    color={color}
                    minAmount={minAmount}
                    amount={amount}
                    key={answerActor.getSnapshot().context.id}
                    matrixNumbersColor={matrixNumbersColor}
                    matrixType={matrixType}
                    size={adjustedSize}
                    style={textStyle}
                    cantRate={cantRate}
                    cantRateText={cantRateText}
                />
            ))}
        </div>
    );
};
